import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService, { type LoginRequest, type LoginResponse } from "@/services/api/auth";

export interface LoginState {
  user: LoginResponse | null;
  isLoading: boolean;
  error: string | null;
  isAuthenticated: boolean;
}

const initialState: LoginState = {
  user: null,
  isLoading: false,
  error: null,
  isAuthenticated: false,
};

export const loginUser = createAsyncThunk(
  "login/loginUser",
  async (credentials: LoginRequest, { rejectWithValue }) => {
    try {
      const response = await AuthService.login(credentials);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Login failed");
    }
  },
);

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.isAuthenticated = false;
      });
  },
});

export const { logout, clearError } = loginSlice.actions;
export default loginSlice.reducer;